var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilegov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1165,
    cy: 22.47,
    rx: 20.9891,
    ry: 22.47,
    fill: "#725798"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1128 30.8964V29.0239C28.1128 28.0307 27.7443 27.0782 27.0882 26.3758C26.4322 25.6735 25.5424 25.2789 24.6146 25.2789H17.6183C16.6905 25.2789 15.8007 25.6735 15.1447 26.3758C14.4887 27.0782 14.1201 28.0307 14.1201 29.0239V30.8964M24.6146 17.7889C24.6146 19.8573 23.0485 21.5339 21.1165 21.5339C19.1845 21.5339 17.6183 19.8573 17.6183 17.7889C17.6183 15.7206 19.1845 14.0439 21.1165 14.0439C23.0485 14.0439 24.6146 15.7206 24.6146 17.7889Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilegov);
export default __webpack_public_path__ + "static/media/profile.gov.b0388118efd1291bae1af08a0228df1f.svg";
export { ForwardRef as ReactComponent };